import Reveal from "@/components/feature/Reveal";
import { teamMembers } from "@/mocks/team";

export default function TeamSection() {
  return (
    <section className="px-4 md:px-8 lg:px-12 py-20 md:py-28">
      <div className="max-w-7xl mx-auto flex flex-col gap-12">
        <Reveal className="flex flex-col items-center gap-4 text-center">
          <span className="text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-primary-600">
            Equipo profesional
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground-900">
            Un equipo detrás de cada proyecto
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {teamMembers.map((member, index) => (
            <Reveal key={member.id} delay={index * 90}>
              <div className="flex flex-col gap-4 rounded-lg border border-background-200/70 bg-background-50 p-6 h-full hover:-translate-y-1.5 transition-transform duration-500">
                <div className="w-full aspect-[4/5] rounded-lg bg-background-100 flex items-center justify-center">
                  <span className="font-heading text-5xl text-foreground-300 select-none">
                    {member.initials}
                  </span>
                </div>
                <div className="flex flex-col gap-1.5">
                  <h3 className="font-heading text-xl text-foreground-900 leading-tight">
                    {member.name}
                  </h3>
                  <p className="text-sm font-medium text-primary-600">{member.profession}</p>
                  <p className="text-sm text-foreground-500">{member.university}</p>
                  <span className="inline-flex self-start rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold px-3 py-1 mt-1 whitespace-nowrap">
                    {member.role}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}